import state from './accountState'
import mutations from './accountMutations'
import actions from './accountActions'
export default {
    namespaced: true,
    state,
    mutations,
    actions,
  }